import { ProductDataSchema } from "@redotech/redo-return-operations-common/customer-portal/product";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getShopNowProducts = unaryRpc({
  name: "getShopNowProducts" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    limit: z.number().int().min(1).max(100).optional(),
    query: z.string().max(500).optional(),
  }),
  output: z.object({ products: z.array(ProductDataSchema) }),
});
